export const MODULE_FORM_SCOPE_DRI = 'dri';
export const MODULE_FORM_SCOPE_PROSPECTO = 'prospecto';

export const resolveModuleFormScope = (visibilityFlag) => (
  visibilityFlag === 'new_edit_premanager'
    ? MODULE_FORM_SCOPE_DRI
    : MODULE_FORM_SCOPE_PROSPECTO
);

export const attachModuleFormScope = (valuesSubmit, visibilityFlag) => ({
  ...valuesSubmit,
  form_scope: resolveModuleFormScope(visibilityFlag)
});
